import { ReactElement } from "react";
import {
  LuBookOpen,
  LuCalendarClock,
  LuLayoutGrid,
  LuTag,
  LuTrafficCone,
} from "react-icons/lu";
import SidebarMenu, { MenuItem } from "../ui/sidebar-menu";
import { SettingsMenuItem } from "./costants";

type SettingsMenuprops = {
  onSelect?: (item: SettingsMenuItem) => void;
};

const MENU_ITEMS: MenuItem<SettingsMenuItem>[] = [
  {
    item: SettingsMenuItem.GENERAL,
    icon: <LuLayoutGrid />,
    labelKey: "settings.menu.general",
  },
  {
    item: SettingsMenuItem.COURTS,
    icon: <LuBookOpen />,
    labelKey: "settings.menu.courts",
  },
  {
    item: SettingsMenuItem.PRICES,
    icon: <LuTag />,
    labelKey: "settings.menu.prices",
  },
  {
    item: SettingsMenuItem.SERVICE_HOURS,
    icon: <LuTrafficCone />,
    labelKey: "settings.menu.service_hours",
  },
  {
    item: SettingsMenuItem.AUTOMATIC_BOOKINGS,
    icon: <LuCalendarClock />,
    labelKey: "settings.menu.automatic_bookings",
  },
];

const SettingsMenu = ({ onSelect }: SettingsMenuprops): ReactElement => (
  <SidebarMenu
    titleKey="settings.menu.settings"
    menuItems={MENU_ITEMS}
    onSelect={onSelect}
  />
);

export default SettingsMenu;
